module.exports = "{{> report_head}}\n{{> recipients}}\n{{> filter_sort}}\n{{> newsletter_actions}}\n\n"